import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    Autocomplete,
    List,
    ListItem,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Image from "../../Utils/getImage";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const AssignSuborder = ({ statusDialog, setstatusDialog, selectedsubOrder, setReload }) => {
    //handle close
    const handleClose = () => {
        setstatusDialog(false);
        //empty the fields
        setsuborderadmin_id('')

    };

    const [admins, setAdmins] = useState([]);
    //fetch admins
    const fetchadmins = async () => {
        try {
            const response = await instance.get('/Admin/getAdmins')
            const filterdata = response?.data?.data?.filter(
                (admin) => admin.role === 'JuniorDesigner'
            );
            const formatteddata = filterdata?.map((employee, index) => ({
                sno: index + 1,
                employeeName: employee?.name,
                employeeId: employee?._id,
                employeeimage: employee?.profile_pic
            }))

            setAdmins(formatteddata);
        }
        catch (error) {
            console.log("error to fetch admins:", error.message)
        }

    }
    useEffect(() => {
        fetchadmins()
    }, [])


    //suborder api call
    const [suborderadmin_id, setsuborderadmin_id] = useState('')

    //assign suborder
    const handleAssignsuborder = async (selectedsubOrder) => {
        if (!suborderadmin_id) {
            toast.error("Please Select Employee In The List !");
            return;
        }
        try {
            const response = await instance.post('/Order/assignSubOrder',
                {
                    order_id: selectedsubOrder._id, // Use `selectedOrder` to access `order_id`
                    admin_id: suborderadmin_id
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setReload()
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }

    return (
        <>

            <React.Fragment>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={statusDialog}
                    className="admin-admins"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Assign Sub Order to an Employee
                        <Typography>
                            Please assign this Sub order to an employee.
                        </Typography>
                    </DialogTitle>
                    <hr style={{ margin: "10px 0px" }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <section className="add-admin">
                            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='add_emloyee-content-text'>
                                        <div className="admin-textfiled">
                                            <Autocomplete
                                                fullWidth
                                                disablePortal
                                                options={admins}
                                                value={admins.find((admin) => admin.employeeId === suborderadmin_id) || null}
                                                getOptionLabel={(option) => option.employeeName}
                                                onChange={(event, value) => setsuborderadmin_id(value?.employeeId || null)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Employee"
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <div className="menu-items-user">
                                                        <Image
                                                            src={option?.employeeimage}
                                                            alt={option?.employeeName}
                                                            width={40}
                                                            height={40}
                                                        />
                                                        <List>
                                                            <ListItem {...props} key={option.employeeId}>
                                                                {option?.employeeName}
                                                            </ListItem>
                                                        </List>
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </section>
                    </DialogContent>
                    <DialogActions>
                        <Button className="cancel-btn" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className="add-btn" onClick={() => handleAssignsuborder(selectedsubOrder)}>Assign Order</Button>
                    </DialogActions>
                </BootstrapDialog>
            </React.Fragment>
        </>
    )
}

export default AssignSuborder;